// src/components/SummaryCards.js
import React, { useState, useEffect } from 'react';
import {
    FiUsers, FiUserCheck, FiUserX, FiTag, FiCheckCircle, FiSlash, FiFileText, FiClock, FiPauseCircle
} from "react-icons/fi";
import './SummaryCards.css';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

const SummaryCards = ({ data }) => {
    const [voucherCounts, setVoucherCounts] = useState({
        total: 0,
        active: 0,
        inactive: 0
    });

    const totalExams = (data.activeExams || 0) + (data.inactiveExams || 0);

    const navigate = useNavigate();

    const handleCardClick2 = (type, category) => {
        if (category === "students") {
            if (type === "active") navigate("/students?status=Active");
            else if (type === "inactive") navigate("/students?status=Inactive");
            else navigate("/students");
        } else if (category === "exams") {
            if (type === "active") navigate("/exams?status=active");
            else if (type === "inactive") navigate("/exams?status=inactive");
            else navigate("/exams");
        } else if (category === "vouchers") {
            if (type === "active") navigate("/admin/active-vouchers");
            else if (type === "inactive") navigate("/admin/inactive-vouchers");
            else navigate("/admin-vouchers");
        }
    };

    const handleCardClick = () => navigate('/manage-students');

    // Fetch vouchers safely
    useEffect(() => {
        const fetchVouchers = async () => {
            try {
                const res = await api.get('/vouchers');
                const vouchersArray = Array.isArray(res.data.data)
                    ? res.data.data
                    : Array.isArray(res.data)
                        ? res.data
                        : [];

                // Use backend status directly
                const normalized = vouchersArray.map(v => ({
                    ...v,
                    status: v.status // 'new', 'running', or 'expired' from backend
                }));

                const activeCount = normalized.filter(v => v.status === 'running').length;
                const inactiveCount = normalized.filter(v => v.status === 'expired').length;
                const totalCount = normalized.length;

                setVoucherCounts({
                    total: totalCount,
                    active: activeCount,
                    inactive: inactiveCount
                });

                console.log("Vouchers from backend:", normalized);

            } catch (err) {
                console.error("Failed to fetch vouchers", err);
                // api.js already handles 401 redirects
            }
        };

        fetchVouchers();
    }, []);

    return (
        <div className="summary-cards-container">
            {/* Students */}
            <div className="summary-card card-blue" onClick={handleCardClick}>
                <div className='summary-card-content'>
                    <FiUsers className="summary-icon icon-blue animate__animated animate__bounceIn" />
                    <div className='summary-text'>
                        <h4>Total Students</h4>
                        <p>{data.totalStudents}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-green" onClick={() => handleCardClick2("active", "students")}>
                <div className='summary-card-content'>
                    <FiUserCheck className="summary-icon icon-green animate__animated animate__fadeInUp" />
                    <div className='summary-text'>
                        <h4>Active Students</h4>
                        <p>{data.activeStudents}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-red" onClick={() => handleCardClick2("inactive", "students")}>
                <div className='summary-card-content'>
                    <FiUserX className="summary-icon icon-red animate__animated animate__zoomIn" />
                    <div className='summary-text'>
                        <h4>Inactive Students</h4>
                        <p>{data.inactiveStudents}</p>
                    </div>
                </div>
            </div>

            {/* Exams */}
            <div className="summary-card card-blue" onClick={() => navigate('/admin/exams')}>
                <div className='summary-card-content'>
                    <FiFileText className="summary-icon icon-teal animate__animated animate__fadeInDown" />
                    <div className='summary-text'>
                        <h4>Total Exams</h4>
                        <p>{totalExams}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-green" onClick={() => handleCardClick2("active", "exams")}>
                <div className='summary-card-content'>
                    <FiClock className="summary-icon icon-orange animate__animated animate__flipInX" />
                    <div className='summary-text'>
                        <h4>Active Exams</h4>
                        <p>{data.activeExams}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-red" onClick={() => handleCardClick2("inactive", "exams")}>
                <div className='summary-card-content'>
                    <FiPauseCircle className="summary-icon icon-gray animate__animated animate__jackInTheBox animate__delay-1s" />
                    <div className='summary-text'>
                        <h4>Inactive Exams</h4>
                        <p>{data.inactiveExams}</p>
                    </div>
                </div>
            </div>

            {/* Vouchers */}
            <div className="summary-card card-blue" onClick={() => handleCardClick2("all", "vouchers")}>
                <div className='summary-card-content'>
                    <FiTag className="summary-icon icon-purple animate__animated animate__bounceIn animate__delay-1s" />
                    <div className='summary-text'>
                        <h4>Total/New Vouchers</h4>
                        <p>{voucherCounts.total}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-green" onClick={() => handleCardClick2("active", "vouchers")}>
                <div className='summary-card-content'>
                    <FiCheckCircle className="summary-icon icon-green animate__animated animate__fadeInLeft" />
                    <div className='summary-text'>
                        <h4>Running/Active Vouchers</h4>
                        <p>{voucherCounts.active}</p>
                    </div>
                </div>
            </div>

            <div className="summary-card card-red" onClick={() => handleCardClick2("inactive", "vouchers")}>
                <div className='summary-card-content'>
                    <FiSlash className="summary-icon icon-red animate__animated animate__fadeInRight" />
                    <div className='summary-text'>
                        <h4>Expired/Inactive Vouchers</h4>
                        <p>{voucherCounts.inactive}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SummaryCards;
